<template lang="pug">
  v-breadcrumbs(v-if="items.length")
    v-icon(slot="divider") chevron_right
    v-breadcrumbs-item(v-for="item in items" :disabled="item.disabled" :key="item.text") {{item.text}}
</template>

<script>
export default {
  props: ['extra'],
  data() {
    return {
      items: []
    }
  }
}
</script>
